<template>
  <div class="form-page">
    <!-- <Header title="问题反馈" background="white" /> -->
    <form action="" class="form" @submit.prevent>
      <div class="input-item" label="反馈内容">
        <van-field
          placeholder="请输入反馈内容，最多50个字哦"
          maxlength="50"
          type="textarea"
          autosize
          rows="1"
          v-model="form.title"
          @input="form.title = form.title.trim()"
        />
      </div>
      <div class="input-item" label="内容补充">
        <van-field
          placeholder="请输入内容补充，最多200个字哦"
          maxlength="200"
          type="textarea"
          autosize
          rows="1"
          v-model="form.content"
          @blur="form.content = form.content.replace(/(\s)\s+/g, '$1').trim()"
        />
      </div>
      <div class="input-item" label="验证码">
        <van-field
          placeholder="请输入验证码"
          v-model="form.captcha"
          @input="form.captcha = form.captcha.trim()"
          maxlength="6"
        >
          <template #right-icon>
            <img
              v-wait-click="getCode"
              wait-click-time="1000"
              :src="icon"
              alt=""
              class="captcha-img"
            />
          </template>
        </van-field>
      </div>
      <button class="btnCom" @click="submit">提交</button>
    </form>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  data() {
    return {
      form: {
        content: "",
        title: "",
        captcha: "",
      },
      icon: "",
      captchaKey: "",
    };
  },
  methods: {
    async submit() {
      if (!this.form.captcha) {
        this.$toast("请输入验证码");
        return;
      }
      if (!this.form.title) {
        this.$toast("请输入反馈内容，最多50个字哦");
        return;
      }
      if (!this.form.content) {
        this.$toast("请输入内容补充，最多200个字哦");
        return;
      }
      if (!(await this.check())) {
        return;
      }
      this.$post({
        module: "Content",
        interface: "5001",
        data: this.form,
      }).then(() => {
        this.$toast("提交成功");
        this.$func.sleep().then(() => this.$router.back());
      });
    },
    getCode() {
      // console.log(123);
      this.$post({
        module: "Utils",
        interface: "1000",
        animation: false,
        data: {},
      }).then((res) => {
        // console.log("验证码", res);
        this.icon = res.captchaContent;
        this.captchaKey = res.captchaKey;
      });
    },
    async check() {
      let result = false;
      await this.$post({
        module: "Utils",
        interface: "1001",
        data: {
          key: this.captchaKey,
          captcha: this.form.captcha,
        },
      })
        .then((res) => {
          // console.log(res);
          if (res.pass) {
            result = true;
          } else {
            result = false;
            this.$toast(res.message);
            this.getCode();
          }
        })
        .catch(() => {
          result = false;
        });
      return result;
    },
  },
  components: {},
  created() {
    this.getCode();
  },
};
</script>

<style scoped lang="less">
.form-page {
  min-height: 100vh;
  background: #fbfbfb;

  .form {
    padding: 14px 16px;

    .input-item {
      padding: 18px 14px 4px;
      background: #ffffff;
      box-shadow: 0px 0px 16px 0px rgba(96, 98, 102, 0.08);
      border-radius: 8px;
      font-size: 14px;
      margin-bottom: 14px;

      .van-cell {
        padding: 0;
        height: 40px;
        display: flex;
        align-items: center;
      }

      &::before {
        content: attr(label);
      }

      .captcha-img {
        width: 78px;
        height: 32px;
      }
    }

    .btnCom {
      border-style: none;
      margin-top: 60px;
      font-size: 17px;
      letter-spacing: 2px;

      &:active {
        background: #c90411;
      }
    }
  }
}
</style>